import { getTypeDomain } from "@src/utils/utils";
import { TFunction } from "i18next";
import React, { FC, useMemo, useState } from "react";

interface OrganisationIDBoxProps {
  t: TFunction;
  setOrganisationId: (newId: string) => void;
  organisationId: string;
  disabled?: boolean;
}

export const OrganisationIDBox: FC<OrganisationIDBoxProps> = ({
  t,
  organisationId,
  setOrganisationId,
  disabled = false,
}) => {
  const [focused, setFocused] = useState(false);
  const orgDomain = useMemo(() => {
    const type = getTypeDomain();
    if (type === "individual") {
      return window.location.host;
    }
    const host = window.location.host;
    const arrHost = host.split(".");
    const individualDomain = arrHost.splice(1, arrHost.length).join(".");
    return individualDomain;
  }, []);

  return (
    <>
      <div className="d-flex align-items-center organisation-input-box">
        <i className="fas fa-sitemap  ico"></i>
        <input
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
          value={organisationId}
          onChange={(e) => {
            setOrganisationId(e.target.value);
          }}
          type="text"
          className="form-control box"
          placeholder={t("organisation_id")}
          name="organisationId"
        />
        <input
          type="text"
          className={`form-control domain ${focused ? "focused" : ""}`}
          disabled
        />
        <span className="text-domain-overlay">.{orgDomain}</span>
      </div>
    </>
  );
};
